/* Dioter · landing 2026 */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Hero ---------- */
  function initHero(root) {
    var h = $('[data-split]', root);
    if (h && !reduce && !h.dataset.done) {
      h.dataset.done = '1';
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (t) {
              if (!t) return;
              if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
              var w = document.createElement('span'); w.className = 'w';
              var s = document.createElement('span'); s.textContent = t; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) { walk(n); }
        });
      })(h);
    }
    var box = $('[data-parallax]', root);
    if (!box || reduce || !window.matchMedia('(pointer:fine)').matches) return;
    var items = $$('[data-depth]', box);
    root.addEventListener('pointermove', function (e) {
      var r = box.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      items.forEach(function (el) { var d = +el.dataset.depth; el.style.translate = (x * d).toFixed(1) + 'px ' + (y * d).toFixed(1) + 'px'; });
    });
    root.addEventListener('pointerleave', function () { items.forEach(function (el) { el.style.translate = '0 0'; }); });
  }

  /* ---------- Best-sellers : achat unique / cure ---------- */
  function initProducts(root) {
    var tog = $('[data-toggle]', root); if (!tog) return;
    var pill = $('.dt-toggle__pill', tog);
    function place() { var b = $('[aria-pressed="true"]', tog); if (!b) return; pill.style.width = b.offsetWidth + 'px'; pill.style.transform = 'translateX(' + b.offsetLeft + 'px)'; }
    function setMode(mode) {
      var cure = mode === 'cure';
      root.classList.toggle('is-cure', cure);
      $$('.dt-card', root).forEach(function (c) {
        var canCure = c.dataset.cure === '1';
        var qty = $('[data-qty]', c);
        if (qty) qty.value = cure && canCure ? 3 : 1;
        $$('[data-show]', c).forEach(function (el) { el.hidden = (el.dataset.show === 'cure') !== (cure && canCure); });
        var one = $('[data-label-one]', c), cl = $('[data-label-cure]', c);
        if (one && cl) { one.hidden = cure && canCure; cl.hidden = !(cure && canCure); }
        var badge = $('[data-badge]', c);
        if (badge) { badge.textContent = cure ? badge.dataset.cure : badge.dataset.one; badge.classList.toggle('is-cure', cure); }
        var price = $('[data-price]', c);
        if (price) { price.classList.remove('flip'); void price.offsetWidth; price.classList.add('flip'); }
      });
    }
    $$('button', tog).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', tog).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        place(); setMode(b.dataset.mode);
      });
    });
    place();
    window.addEventListener('resize', place);
    if (document.fonts) document.fonts.ready.then(place);
  }

  /* ---------- Diagnostic conversationnel ---------- */
  function initDiag(root) {
    var chat = $('[data-chat]', root); if (!chat) return;
    var data = {}; try { data = JSON.parse($('[data-diag-products]', root).textContent); } catch (e) {}
    var P = data.products || {};
    var dots = $$('.dt-chat__steps i', root);
    var Q = [
      { q: 'Bonjour ! Qu’est-ce qui vous amène aujourd’hui ?', key: 'need', opts: [['imm', 'Mes défenses cet hiver'], ['vit', 'Plus d’énergie'], ['art', 'Mes articulations'], ['som', 'Me détendre, mieux dormir']] },
      { q: 'C’est noté. C’est pour vous ou pour votre enfant ?', key: 'who', opts: [['me', 'Pour moi'], ['kid', 'Pour mon enfant']] },
      { q: 'Dernière question : vous connaissez déjà Dioter ?', key: 'known', opts: [['yes', 'Oui, je suis client'], ['no', 'Je découvre']] }
    ];
    var ans = {}, step = 0;
    function scroll() { chat.scrollTop = chat.scrollHeight; }
    function say(html, me) { var d = document.createElement('div'); d.className = 'dt-msg' + (me ? ' me' : ''); d.innerHTML = html; chat.appendChild(d); scroll(); }
    function sayText(t, me) { var d = document.createElement('div'); d.className = 'dt-msg' + (me ? ' me' : ''); d.textContent = t; chat.appendChild(d); scroll(); }
    function typing(cb) { var t = document.createElement('div'); t.className = 'dt-msg dt-typing'; t.innerHTML = '<i></i><i></i><i></i>'; chat.appendChild(t); scroll(); setTimeout(function () { t.remove(); cb(); }, reduce ? 0 : 750); }
    function options(s) {
      var o = document.createElement('div'); o.className = 'dt-opts';
      s.opts.forEach(function (op) { var b = document.createElement('button'); b.type = 'button'; b.className = 'dt-opt'; b.dataset.v = op[0]; b.textContent = op[1]; o.appendChild(b); });
      chat.appendChild(o); scroll();
      o.addEventListener('click', function (e) {
        var b = e.target.closest('.dt-opt'); if (!b) return;
        ans[s.key] = b.dataset.v; o.remove(); sayText(b.textContent, true); step++;
        step < Q.length ? ask() : result();
      });
    }
    function ask(instant) {
      dots.forEach(function (d, i) { d.classList.toggle('on', i <= step); });
      var s = Q[step];
      if (instant) { sayText(s.q); options(s); return; }
      typing(function () { sayText(s.q); options(s); });
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
    function result() {
      typing(function () {
        var key = ans.need + '_' + ans.who, p = P[key];
        if (!p) {
          say('Pour ce besoin, notre équipe préfère vous conseiller de vive voix : <b>' + esc(data.phone) + '</b>, du lundi au vendredi.');
          restart(); return;
        }
        var client = ans.known === 'yes' && p.plan;
        sayText(p.plan ? 'Voici la formule que nous vous conseillons. En cure de 3 flacons (3 mois), vous économisez ' + p.pct + ' %.' : 'Voici la formule que nous vous conseillons.');
        var r = document.createElement('div'); r.className = 'dt-result';
        r.innerHTML = (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="110" height="110">' : '<span></span>') +
          '<div><h4>' + esc(p.title) + '</h4><p>' + esc(p.desc) + '</p><div class="dt-result__row">' +
          (p.plan ? '<form action="/cart/add" method="post"><input type="hidden" name="id" value="' + p.variant + '"><input type="hidden" name="quantity" value="3">' +
          '<button type="submit" class="dt-btn dt-btn--primary">Cure 3 flacons · ' + esc(p.cure) + '</button></form>' : '') +
          '<form action="/cart/add" method="post"><input type="hidden" name="id" value="' + p.variant + '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="dt-btn ' + (p.plan ? 'dt-btn--ghost' : 'dt-btn--primary') + '">1 flacon · ' + esc(p.price) + '</button></form>' +
          '<a class="dt-btn dt-btn--ghost" href="' + esc(p.url) + '">Voir la fiche</a>' +
          '<button type="button" class="dt-btn dt-btn--ghost" data-restart>Recommencer</button></div></div>';
        chat.appendChild(r); scroll();
      });
    }
    function restart() { var o = document.createElement('div'); o.className = 'dt-opts'; o.innerHTML = '<button class="dt-opt" type="button" data-restart>Recommencer</button>'; chat.appendChild(o); scroll(); }
    chat.addEventListener('click', function (e) { if (e.target.closest('[data-restart]')) { chat.innerHTML = ''; ans = {}; step = 0; ask(); } });
    chat.innerHTML = ''; ask(true);
  }

  /* ---------- Cure : frise + calculateur ---------- */
  function initCure(root) {
    var tl = $('[data-timeline]', root);
    if (tl && !reduce) {
      var fill = $('.dt-timeline__fill', tl);
      var upd = function () { var r = tl.getBoundingClientRect(), vh = innerHeight; var p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (r.height + vh * 0.35))); fill.style.setProperty('--p', p.toFixed(3)); };
      addEventListener('scroll', upd, { passive: true }); upd();
    }
    var list = $('[data-picks]', root); if (!list) return;
    var out = function (k) { return $('[data-out="' + k + '"]', root); };
    function tween(el, to) {
      var from = parseFloat(el.dataset.v); el.dataset.v = to;
      if (reduce || isNaN(from)) { el.textContent = money(to); return; }
      var t0 = performance.now();
      (function f(t) { var k = Math.min(1, (t - t0) / 600), e = 1 - Math.pow(1 - k, 3); el.textContent = money(from + (to - from) * e); if (k < 1) requestAnimationFrame(f); })(t0);
    }
    function calc(b) {
      var price = +b.dataset.price, pm = +b.dataset.pm, po = +b.dataset.po, total = price * 3;
      tween(out('one'), total);
      tween(out('pm'), total * (100 - pm) / 100);
      tween(out('po'), total * (100 - po) / 100);
      tween(out('save'), total * Math.max(pm, po) / 100);
      out('pm-l').textContent = pm ? '−' + pm + ' %' : '';
      out('po-l').textContent = po ? '−' + po + ' %' : '';
      out('link').href = b.dataset.url;
    }
    list.addEventListener('click', function (e) {
      var b = e.target.closest('.dt-pick'); if (!b) return;
      $$('.dt-pick', list).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      calc(b);
    });
    var first = $('.dt-pick[aria-pressed="true"]', list) || $('.dt-pick', list);
    if (first) calc(first);
  }

  /* ---------- Plantes ---------- */
  function initAtlas(root) {
    var stage = $('[data-stage]', root); if (!stage) return;
    var figs = $$('figure', stage), tag = $('[data-tag]', stage), items = $$('[data-plant]', root);
    function set(i) {
      items.forEach(function (el) { el.classList.toggle('on', +el.dataset.i === i); });
      figs.forEach(function (f) { f.classList.toggle('on', +f.dataset.i === i); });
      if (items[i] && tag) tag.textContent = items[i].dataset.part || '';
    }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) set(+e.target.dataset.i); }); }, { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Bordures lumineuses (effet « glowing cards ») ---------- */
  function initGlow(scope) {
    if (!window.matchMedia('(pointer:fine)').matches) return;
    $$('[data-glow]', scope).forEach(function (group) {
      if (group.dataset.glowReady) return; group.dataset.glowReady = '1';
      var cards = $$('.dt-glow', group), raf = 0, ev = null;
      function paint() {
        raf = 0;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          c.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
          c.style.setProperty('--my', (ev.clientY - r.top) + 'px');
        });
      }
      group.addEventListener('pointermove', function (e) { ev = e; if (!raf) raf = requestAnimationFrame(paint); });
    });
  }

  /* ---------- Apparitions + compteurs ---------- */
  function initReveal(root) {
    if (reduce || !('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) return;
    var vh = innerHeight;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('go'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px 12% 0px' });
    $$('.dt-rv', root).filter(function (el) { return el.getBoundingClientRect().top > vh * 0.98; }).forEach(function (el) { io.observe(el); });
    var co = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; co.unobserve(e.target);
        var el = e.target, to = parseFloat(el.dataset.countTo), dec = +(el.dataset.dec || 0), t0 = performance.now();
        if (isNaN(to)) return;
        (function f(t) { var k = Math.min(1, (t - t0) / 1400), v = to * (1 - Math.pow(1 - k, 3)); el.textContent = v.toFixed(dec).replace('.', ','); if (k < 1) requestAnimationFrame(f); })(t0);
      });
    }, { rootMargin: '0px 0px 5% 0px' });
    $$('[data-count-to]', root).filter(function (el) { return el.getBoundingClientRect().top > vh; }).forEach(function (el) { co.observe(el); });
  }

  var inits = { hero: initHero, products: initProducts, diag: initDiag, cure: initCure, atlas: initAtlas };
  function boot(scope) {
    $$('[data-dt]', scope).forEach(function (el) { var f = inits[el.dataset.dt]; if (f) f(el); });
    initGlow(scope);
    initReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
